import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue';
import AddBar from '../views/owners/add';
Vue.use(VueRouter)

const routes = [
  {
    path: '/owners/add',
    name: 'AddBar',
    component: AddBar
  },
  {
    path: '',
    name: 'Home',
    component: Home
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
